import {v4} from 'uuid'

export default {
	projects: [
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nv200-unit-1/index.html',
			projectImageUrl: './images/nv200-unit-1.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nv200-unit-2/index.html',
			projectImageUrl: './images/nv200-unit-2.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nvc-titan-unit-1/index.html',
			projectImageUrl: './images/nvc-titan-unit-1.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vw-appconnect-01/index.html',
			projectImageUrl: './images/vw-appconnect-01.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vw-blind-spot/index.html',
			projectImageUrl: './images/vw-blind-spot.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vw-appconnect-02/index.html',
			projectImageUrl: './images/vw-appconnect-02.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/avvo/index.html',
			projectImageUrl: './images/avvo.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nintendo-pokemon/index.html',
			projectImageUrl: './images/nintendo-pokemon.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/rcm/index.html',
			projectImageUrl: './images/rcm.png',
		},
		// {
		// 	id: v4(),
		// 	title: '',
		// 	description: '',
		// 	url: './projects/quesalupa/index.html',
		// 	projectImageUrl: './images/quesalupa.jpg',
		// },
		// {
		// 	id: v4(),
		// 	title: '',
		// 	description: '',
		// 	url: './projects/vw-golf-family/index.html',
		// 	projectImageUrl: './images/vw-golf-family.png',
		// },
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vw-golf-power/index.html',
			projectImageUrl: './images/vw-golf-power.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vw-passat/index.html',
			projectImageUrl: './images/vw-passat.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vw-premier-league/index.html',
			projectImageUrl: './images/vw-premier-league.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/commercial-warranty/index.html',
			projectImageUrl: './images/commercial-warranty.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/leaf-access/index.html',
			projectImageUrl: './images/leaf-access.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nissan-armada/index.html',
			projectImageUrl: './images/nissan-armada.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/zillow/index.html',
			projectImageUrl: './images/zillow.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/Pacific_Standard_Time/index.html',
			projectImageUrl: './images/Pacific_Standard_Time.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/dyk-awareness/index.html',
			projectImageUrl: './images/dyk-awareness.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nissan-rogue/index.html',
			projectImageUrl: './images/nissan-rogue.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nv-cargo-unit-1/index.html',
			projectImageUrl: './images/nv-cargo-unit-1.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nv-cargo-unit-2/index.html',
			projectImageUrl: './images/nv-cargo-unit-2.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nv-passenger-unit-1/index.html',
			projectImageUrl: './images/nv-passenger-unit-1.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/nv-passenger-unit-2/index.html',
			projectImageUrl: './images/nv-passenger-unit-2.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/pfg-ira-2017/index.html',
			projectImageUrl: './images/pfg-ira-2017.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/pfg-spring_unit-2/index.html',
			projectImageUrl: './images/pfg-spring_unit-2.jpg',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/proclean-usatoday/index.html',
			projectImageUrl: './images/proclean-usatoday.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/qb-organize/index.html',
			projectImageUrl: './images/qb-organize.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/viking-aniversary/index.html',
			projectImageUrl: './images/viking-aniversary.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/viking-dykrsocean/index.html',
			projectImageUrl: './images/viking-dykrsocean.png',
		},

		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/samsung/index.html',
			projectImageUrl: './images/samsung.png',
		},
		{
			id: v4(),
			title: '',
			description: '',
			url: './projects/vanity/index.html',
			projectImageUrl: './images/vanity.png',
		},
	]
}



// WEBPACK FOOTER //
// ./src/Seed.js